import BentoLoad from '../assets/BentoLoad.mp4';

export function Testimonial() {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-[1280px] mx-auto px-5 md:px-10 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left: Product Demo */}
          <div className="relative aspect-square lg:aspect-590/669 rounded-2xl overflow-hidden bg-black shadow-lg">
            <video
              className="absolute inset-0 h-full w-full object-cover"
              src={BentoLoad}
              autoPlay
              loop
              muted
              playsInline
            >
              Your browser does not support the video tag.
            </video>
          </div>

          {/* Right: Quote */}
          <div className="space-y-8 lg:py-12">
            <blockquote className="text-2xl md:text-3xl lg:text-4xl font-light leading-relaxed">
              "Bento is simple, intentional, and beautifully designed. It lets me bring order to the
              chaos of my screen."
            </blockquote>

            <div className="space-y-1">
              <p className="text-base md:text-lg font-medium">Scott Mellor</p>
              <p className="text-sm text-gray-600">Art Director, StudioThinkTank</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

